import { QUESTIONNAIRE_KEY as EMPLOYEE_SECTION_QUESTIONNAIRE_KEY } from "@teamprevent/common/ppq/components/PpqEmployeeForm";
import { QUESTIONNAIRE_KEY as MANAGER_SECTION_QUESTIONNAIRE_KEY } from "@teamprevent/common/ppq/components/PpqManagerSection";

import { selectQuestionnaireAsQuestionnaireConfigFactory } from "../questionnaires/questionnaireConfig";

export const selectEmployeeSectionQuestionnaireAsQuestionnaireConfig = selectQuestionnaireAsQuestionnaireConfigFactory(EMPLOYEE_SECTION_QUESTIONNAIRE_KEY);
export const selectManagerSectionQuestionnaireAsQuestionnaireConfig = selectQuestionnaireAsQuestionnaireConfigFactory(MANAGER_SECTION_QUESTIONNAIRE_KEY);
